import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { PedidoInterface } from "app/module/pedido-interface";
import moment from "moment";
import { PlanoService } from "@core/services/plano.service";
import { ContratoService } from "@core/services/contrato.service";

@Component({
	selector: 'app-listar-contrato',
	templateUrl: './listar-contrato.component.html',
	styleUrls: ['./listar-contrato.component.scss']
})
export class ListarContratoComponent implements OnInit {
	constructor(
		private contratoService: ContratoService,
		private cdr: ChangeDetectorRef
	) {
		this._unsubscribeAll = new Subject();
	}

	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	starting = false;
	contentHeader: object;
	basicSelectedOption: number = 10;
	ColumnMode = ColumnMode;
	rows: Array<PedidoInterface> | any = [];
	temp: Array<PedidoInterface> | any = [];
	selectedStatus: any;
	dateOptions = {
		altInput: true,
		mode: 'single',
		altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
		defaultDate: moment(new Date).format('YYYY-MM-DD'),
		altFormat: "d/m/Y",
	};

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		try {

		} catch (error) {

		} finally {
			this.cdr.detectChanges();
		}
		this.starting = true;
		this.contentHeader = {
			headerTitle: "Contratos",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Contrato",
						isLink: false,
					},
				],
			},
		};

		this.contratoService.get().subscribe(
			(res) => {
				(this.rows = res), (this.temp = res), (this.tempData = this.rows);
				this.starting = false;
			},
			(error) => {
				console.log(error);
				this.starting = false;
			}
		);
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	dateFilter(event) {
		const val = event.target.value.toLowerCase();
		const [day, month, year] = val.split("/");
		const result = [year, month, day].join("-");
		if (val.length < 10) {
			this.rows = this.temp;
		}
		if (val.length == 10) {
			// filter our data
			const temp = this.temp.filter(function (d) {
				return d.dt_insert.substring(0, 10).toLowerCase().indexOf(result) !== -1 || !result;
			});
			// update the rows
			this.rows = temp;
			// Whenever the filter changes, always go back to the first page
			this.table.offset = 0;
		}
	}

	textFilter(event, param) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	confirmDeleteAlert(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja excluir o item?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				// return this.pedidoService.delete(1, data).subscribe(
				// 	(res) => {
				// 		Swal.fire({
				// 			title: "Sucesso!",
				// 			text: "O item foi excluído.",
				// 			icon: "success",
				// 			confirmButtonText: "Confirmar",
				// 		}).then((result) => {
				// 			if (result.isConfirmed) {
				// 				this.pedidoService.get().subscribe(
				// 					(res) => (this.rows = res),
				// 					(error) => error
				// 				);
				// 			}
				// 		});
				// 	},
				// 	(error) => {
				// 		Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
				// 	}
				// );
			}
		});
	}

}
